(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2533],{

/***/ 56980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/grailed-authentication/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-05-15",
      tag: "Grailed",
      title: "Grailed Authentication 101: How it Works and Why Does it Matter",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed is one of the most popular sites where you can buy and sell designer menswear, limited-edition sneakers, streetwear, accessories, and many more.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["However, like other marketplaces, some counterfeited items get passed on as authentic, causing problems for buyers and sellers. To prevent inauthenticity issues on your Grailed listings, we'll go over what authentication means on Grailed, why it's crucial for sellers, and some tips on what you can do while waiting for Grailed to authenticate your products digitally.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What is Digital Authentication"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Many sellers on Grailed wonder what digital authentication is and why it matters. Digital authentication on Grailed means verifying the authenticity of your item digitally without the need to send the items to Grailed for physical verifications.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Digital authentication is one of the simplest and fastest ways to have your item authenticated and give buyers assurances that they are purchasing authentic items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How it Helps Grailed Sellers"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Aside from the assurances, it provides for your buyers\u2013 it's also more sustainable as no shipments are needed than having it authenticated physically.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The following are other benefits it provides to sellers:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Saves you money. No authentication fees are charged to sellers. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Peace of mind. You don't have to ship the item twice, and the condition of your items will not be compromised."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Saves you time. Having your items digitally authenticated only takes a few hours. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Having a digital authentication badge helps sellers sell their high-valued items easily and fast. "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How Grailed Authentication Works"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed aims to provide its user's confidence when buying and selling inside the platform. Grailed implements a strict digital authentication listing process to prevent counterfeited items from passing as authentic.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Their set of moderators and authenticity reviewers are trained team brand and marketplace experts. They are experts in identifying brands, conditions, and quality of menswear clothing and accessories. Moreover, Grailed digital moderators are up to date with fraud trends, which lets them differentiate authentic from counterfeited items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Grailed digital moderators determine fakes from original items by examining the following: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Item's design features, craftsmanship, and detailing. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Item's authenticity features (i.e., wash tags, logo size and shape, embroidery) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The accuracy of the item name and product description (Photo matching with the product image and listing title/product)"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["The authentication process starts once you list your items on the platform. Grailed expert moderators will thoroughly examine the listing to determine the item's authenticity, depending on the photos you provided. Once your listing passes the authenticity check, Grailed will add an authenticated label on the item's page to assure buyers that the item they want to buy is genuine.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Do all products need to be authenticated?"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Not all listings are required to have authentication. However, it still depends on your item's category or type. Grailed recommends providing precise and detailed photographs of your items and their authenticity indicators to get your listings to go live."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "For high-risk items, it must go through Grailed moderators first and have the digital authentication label before it can be published. Grailed may also ask for additional supporting documents or clear photos of authenticity indicators to ensure they have all the information needed to review your products as accurately and fast as possible."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Determining High-Risk Item "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Grailed is stringent in examining high-risk items from going live on the platform. They are using both human and machine moderators to check authenticity indicators and analyze whether the thing is authentic or not."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "They are also proactive in monitoring unusual content and activity, especially on new releases and highly-anticipated brands, to prevent replicas or counterfeited items from being listed on the site."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Grailed determines if the item is high-risk through various factors, such as the following: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The listing price vs. its market value "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The brand or style's vulnerability, or how easy it to be replicated. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Unusual activity and changes on the account (updated emails or bank accounts) "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Users' track record and how long they've been on the platform. "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "The actual worth or value of the item "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["All items determined as high-risk, like Supreme, Jordan, and other high-end menswear, should have digital authentication badges before going live. This is done to ensure buyer protection and prevent counterfeited items from passing as authentic.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Four Common Fake Items that Passed as Authentic "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Grailed aims to provide speed and accuracy in analyzing and giving authentication labels to all items deemed authentic. However, the system sometimes fails to capture fake items, which get passed on as Authentic.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The following are some of the common fake items that Grailed sometimes unknowingly passed as authentic: "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Designer items - Most common brands are Gucci, Chanel, Louis Vuitton, and other easily replicated designer styles."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["New Streetwear releases - These are highly anticipated and the latest drops of popular brands like Supreme, Yeezy, Air Jordan, and the likes.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["High-end Classic Menswear - These can be anything from clothing to footwear, such as brands like Alden, Tom Ford, and Brunello Cucinelli.", ' ']
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: ["Vintage Clothing - These items are anything under 100 years but not over 20 years and are usually valued higher depending on their style and era.", ' ']
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["While Grailed is committed to ensuring accuracy in spotting fakes to authentic, you should still be very wary in selling easily replicated items. If sellers are caught selling inauthentic items, they can face severe penalties, including account deletion.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to Report Inauthentic Items "
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you come across other sellers selling with a suspicious listing or suspect they are selling fake items based on their listing photos, you may report it on Grailed. To report, simply click the \"Report Listing\" button located on the listing page.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["It will automatically notify the moderation team and will make a thorough investigation. You can expect a response from them regarding your reported listing within 12 hours.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What happens to items that are deemed inauthentic"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["If you are found to be selling inauthentic items, you will receive a notice/ warning from Grailed about the suspicious object. You can send supporting documents or clear pictures of its authenticity indicators to prove that you are selling an authentic product.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["However, if your product is proven to be a replica or a counterfeit item, your account will be permanently frozen.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What happens to sellers who try to publish inauthentic items?"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Sellers trying to sell inauthentic items will be punished severely, including having their accounts permanently frozen. This is part of Grailed's zero-tolerance policy and keeps Grailed a safe place where buyers can buy items confidently, and resellers can get the best value for their items.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Do More While Waiting "
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "While it can be frustrating to wait for your items to pass the digital authentication process before you can start selling on Grailed, it's still worth the wait. Based on Statistics, having your items authenticated digitally, especially those high-risk items, lets you sell them at a reasonable price and faster. Plus, it gives your buyers assurances that you are selling authentic items."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["So, what else can you do while waiting for your item to be authenticated? You can do a lot and still earn while waiting if you have a tool like OneShop.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop's cross-listing feature lets you easily create drafts where you can quickly cross-list across multiple platforms. Furthermore, their de-listing feature works side-to-side with the cross-list feature, so you can avoid selling a single item on various platforms since it automatically detects and de-lists once you sell.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In addition to the great features OneShop can do for your reselling business, you can also monitor and track your progress as a seller. OneShop also offers features that allow you to set your listing, track your sales, and manage your sales goals."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Thousands of online resellers trust OneShop and our app community is continuously growing. It is an all-in-one tool that can help you increase your sales and ultimately grow your reselling business.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Sign-up now"
        }), " with no upfront payment required! Take advantage of its unique features with its 7-day free trial."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/grailed-authentication.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Grailed Authentication 101: How it Works and Why Does it Matter"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Learn how Grailed authentication works, why having your items digitally authenticated matters, and how to get more money by selling your authentic items on Grailed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/grailed-authentication"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/grailed-authentication"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Grailed Authentication 101: How it Works and Why Does it Matter"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Learn how Grailed authentication works, why having your items digitally authenticated matters, and how to get more money by selling your authentic items on Grailed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 99756:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/grailed-authentication",
      function () {
        return __webpack_require__(56980);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(99756); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);